import React from 'react';
import TitleDivided from '../../../shared/components/title-divided/title-divided';
import UseCases from './use-cases';
import './transformative-use-cases.scss';

function TransformativeUseCases({ content }) {
  const { header, use_cases: useCases } = content;
  return (
    <div className='transformative wrapper-fluid'>
      <TitleDivided className='title-divided-padding-bottom' content={header} />
      <UseCases className='grid-template three-columns' useCases={useCases} />
    </div>
  );
}

export default TransformativeUseCases;
